<template>
  <div class="home">
    <main-map></main-map>
  </div>
</template>

<script>
// @ is an alias to /src
import MainMap from '@/components/MainMap';
export default {
  name: 'home',
  components: {
    MainMap
  }
};
</script>
